/**
 * Quién puede administrar qué espacio, visto desde la interfaz.
 *
 * Hay dos niveles:
 *   - Administrador (rol "admin"): todo, en todos los espacios y en el panel.
 *   - Encargado de espacio: un colaborador normal al que el administrador le
 *     asignó uno o varios espacios. `currentUser.managedSpaces` trae sus ids
 *     (lo envía el backend al iniciar sesión y en /api/auth/me).
 *
 * Esto solo decide qué botones se muestran. El permiso real lo vuelve a
 * comprobar el servidor en cada acción (backend/services/spaceAdmins.js), así
 * que mostrar un botón de más nunca concede nada.
 */

// Único espacio donde publica cualquier colaborador (el muro general). Tiene
// que coincidir con ESPACIO_ABIERTO_ID del backend.
export const ESPACIO_ABIERTO_ID = 3;

export const esAdmin = (usuario) => usuario?.rol === "admin";

/** Ids (numéricos) de los espacios de los que la persona es encargada. */
export const espaciosAdministrados = (usuario) =>
  Array.isArray(usuario?.managedSpaces) ? usuario.managedSpaces.map(Number) : [];

/** Administrador, o encargado de ese espacio en concreto. */
export const puedeAdministrarEspacio = (usuario, spaceId) => {
  if (esAdmin(usuario)) return true;
  const id = Number(spaceId);
  return Number.isInteger(id) && id > 0 && espaciosAdministrados(usuario).includes(id);
};
